import { render, staticRenderFns } from "./ProtestoIhtarForm.vue?vue&type=template&id=303fda08"
import script from "./ProtestoIhtarForm.vue?vue&type=script&lang=ts"
export * from "./ProtestoIhtarForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports